

import React, {useState} from 'react'
import FieldDropdown from '../FieldDropdown'
import { exportExcel } from '../../lib/excel'
import { useCreateReplace, useDeleteDocument } from '../../hooks/mutations'
import { keyId, addValueForDropdown, copyId, errorAlert, addNameSwal, successAlert} from '../../lib/utils'
import VisDiv from '../frontend_components/VisDiv'
import { useStateContext } from '../../context/StateContext'
import {  ReferenceCheckList, ReferencesArrayBox } from './ManagementModules'
import { StepByStepProgress } from './StepByStepProgress'
import {Divider, SliderRegistriTemplates, TextField, ViewLabelValueField} from '../../components'
import TrueFalseToggle from '../TrueFalseToggle'
import { richEditorDoc, referenceDoc } from '../gestioneDatabase/Docs'
import { v4 as uuidv4 } from 'uuid';
import RichTextEditor from '../RichTextEditor'
import {FiCopy } from 'react-icons/fi'
import { useQueryClient } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { _FETCH } from '../../lib/patches'
import { useAuthContext } from '../../hooks/useAuthContext'
import register from '../../sanity_ecommerce/schemas/register'
import TestButton from '../frontend_components/TestButton'
import { useManagementContext } from '../../context/ManagementContext'
import Swal from 'sweetalert2'
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";

/**
 * DeviceTemplatesManagement
 * 
 * Component for managing device templates
 * 
 * #registerManagement
 * #offerManagement
 * 
 * @param {object} data - data to be passed to the component,  {templateRegister, presidioModules, templateRegisters, hideCloseButton}
 * @param {string[]} queryKey - key to be used for the query, default ['presidioModules']
 */
const DeviceTemplatesManagement = ({queryKey=['presidioModules'], data={}}) => {
    const {templateRegister, presidioModules, templateRegisters, hideCloseButton} = data
    const queryClient = useQueryClient()
  
    const {
          sUser,
          customer,
          apiUrl,          
    } = useStateContext();

    const { user } = useAuthContext()

    const {newPresidioModule, setNewPresidioModule, newPresidioModuleEdited, setNewPresidioModuleEdited} = useManagementContext()

    const {mutate: updateRegisterTemplate} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['templateRegisters'] })
            const previousData = queryClient.getQueryData(['templateRegisters'])
    
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['templateRegisters'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData }
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("Errore: il documento non é stato aggiornato")
        },
        onSuccess: (data, variables) => {
            successAlert("MODELLO REGIASTRO AGGIORNATO CON SUCCESSO")
        }
    })

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: queryKey })
            const previousData = queryClient.getQueryData(queryKey)
    
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(queryKey, (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return {previousData }
        },

        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message)
            errorAlert("Errore: il documento non é stato aggiornato")
        },
        onSuccess: (data, variables) => {
            successAlert("PRESIDIO AGGIORNATO CON SUCCESSO")
            setNewPresidioModuleEdited(false)
        }
    })

    const customerId = customer?._id ? customer?._id : sUser?.customer?._ref
    const save = (data, bypassEdit) => {
        setNewPresidioModule(data)
        if(!bypassEdit){setNewPresidioModuleEdited(true)}
        //updateDocument({doc: data})
        console.log("SAVE PRESIDIO DOC:", data)
    }
    const updateDatabase = async(doc) => {
           await updateDocument({doc: doc})
    }

    const resetDoc = async() => {
        if(newPresidioModuleEdited){
            const result = await Swal.fire({
                title: 'Documento Non Salvato',
                text: 'Vuoi uscire ugualmente? i dati andranno persi.',
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Chiudi Documento',
                cancelButtonText: 'Annulla'
            });
        
            if (result.isConfirmed) {
                // Fall back to mailto
                setNewPresidioModule(undefined)
                setNewPresidioModuleEdited(false)
            }
        } else {
            setNewPresidioModule(undefined)
            setNewPresidioModuleEdited(false)
        }
                
    }
    const archive = async () => {
        const archivedDoc = {...newPresidioModule, status:"ARCHIVIATO"}
        console.log("ARCHIVIA", archivedDoc)
        // Update cache first
        await updateDocument({doc: archivedDoc});
        // Then update local state
        setNewPresidioModule(archivedDoc);
        setNewPresidioModuleEdited(false)
    }
    const restore = async () => {
        const restoredDoc = {...newPresidioModule, status:"ATTIVO"}
        console.log("ATTIVA", restoredDoc)
        // Update cache first
        await updateDocument({doc: restoredDoc});
        // Then update local state
        setNewPresidioModule(restoredDoc);
        setNewPresidioModuleEdited(false)
    }  

    const templateRegistersReferenceData = {type: "referenceArray", hideFilter:true, data: templateRegisters, propertyName: "templates"}

    const progressList = [
    {description: "NOME PRESIDIO", component: <PresidioName doc={newPresidioModule} setDoc={save} data={{}}/>},
    {description: "ASSEGNA TIPOLOGIE REGISTRO", component: <AssignRegisterTemplates updateRegisterTemplate={updateRegisterTemplate} doc={newPresidioModule} setDoc={save} data={{referenceData: templateRegistersReferenceData}}/>},
    {description: "IMPOSTAZIONI", component: <ModulePresidioSettings doc={newPresidioModule} setDoc={save} />},
    {description: "ORDINE IN TEMPLATE", component: <TemplateOrder updateRegisterTemplate={updateRegisterTemplate} doc={newPresidioModule} setDoc={save} data={{templateRegisters, presidioModules}} />},
    ]

    
    const consoleData = {newPresidioModule, templateRegisters}
    if(sUser?.userType !== "God Mode" && sUser?.userType !== "Admin"){
        return <NoAccessMessage/>  
    } 
    if (!customerId){return <p>Customer not found</p>}

   return (
        <div style={{overflow:"auto", height:"88vh", paddingBottom:"100px"}}>
            <h2>GESTIONE PRESIDI</h2>
            <TestButton buttonId={"dhwiudwiudhj"} message='MANAGE MODULI PRESIDI' consoleData={consoleData}/>
            <div style={{display: "flex", alignItems:"center"}}>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}} rules={[newPresidioModule]}>
                    <button onClick={resetDoc} className={"pdf-button"}>CHIUDI DOCUMENTO</button>
                </VisDiv>
                <VisDiv style={{marginRight:"10px", marginBottom:"10px",}}  rules={[newPresidioModule]}>
                    <button type="button" disabled={!newPresidioModuleEdited} style={{backgroundColor: newPresidioModuleEdited ? "green" : "grey"}} className="pdf-button" onClick={()=>updateDatabase(newPresidioModule)} >
                        {"SALVA DOCUMENTO"}
                    </button>
                </VisDiv>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newPresidioModule && newPresidioModule?.status !== "ARCHIVIATO"]}>
                    <button type="button" style={{backgroundColor: "red"}} className="pdf-button" onClick={()=>archive()} >
                        {"ARCHIVIA"}
                    </button>
                </VisDiv>
                <VisDiv style={{marginBottom:"10px", marginRight:"10px"}}  rules={[newPresidioModule?.status == "ARCHIVIATO"]}>
                    <button type="button" style={{backgroundColor: "green"}} className="pdf-button" onClick={()=>restore()} >
                        {"RIPRISTINA"}
                    </button>
                </VisDiv>
            </div>

            <VisDiv rules={[newPresidioModule?.label]} style={{textAlign:"center"}}>
                <h2>PRESIDIO: {newPresidioModule?.label}</h2>
            </VisDiv>
            <VisDiv rules={[!newPresidioModule]}>
                <AddOrEditPresidioModule updateDatabase={updateDatabase} doc={newPresidioModule} setDoc={save} data={{...data, presidioModules}}/>
            </VisDiv>
            <VisDiv rules={[newPresidioModule]}>
                <StepByStepProgress progressList={progressList}/>
            </VisDiv>

        </div>
    )


   
}


/**
 * AddOrEditPresidioModule component
 * 
 * This component allows the user to select an existing presidio module, 
 * edit it, or create a new one. It also allows the user to filter the list 
 * of available presidio modules by their family, and to duplicate an existing 
 * presidio module.
 * 
 * @param {Object} data - an object containing the data needed by the component,  {presidioModules, templateRegisters} 
 * @param {Function} updateDatabase - a function that updates the database with a new or modified presidio module
 * @param {Function} setDoc - a function that sets the current presidio module
 * 
 * @returns - a JSX element
 */
export const AddOrEditPresidioModule = ({doc, updateDatabase, setDoc, data={}}) => { 
    
    const {customer} = useStateContext()
    const [presidioName, setPresidioName] = useState("")
    const [selectedPresidioModule, setSelectedPresidioModule] = useState("")
    const {presidioModules, templateRegisters} = data 
    const [viewFilterFamily, setViewFilterFamily] = useState(false)
    const [templateRegister, setTemplateRegister] = useState()
    const [filterType, setFilterType] = useState({label: "ATTIVI", value: 1})
    const filterTypes = [
        {label: "ATTIVI", value: 1},
        {label: "ARCHIVIATI", value: 2},
        {label: "SENZA REGISTRI AGGIORNATI", value: 3},
        {label: "CON ALCUNI REGISTRI MANCANTI", value: 4},
    ]

    const duplicateDoc = () => ({
        ...selectedPresidioModule,
        templates: [],
        label: presidioName, 
        _id: uuidv4(), 
        _key: keyId(),
    })

    const emptyDoc = () => ({
        _type: "presidioModule",
        _id: uuidv4(),
        _key: keyId(),
        label: "",
        customer: referenceDoc(customer?._id),
        templates: [],
        templatesExclude: false,
        isConsole:false,
        oldRevisionYears: undefined,//number
        revisionYears: undefined,//number
        testYears: undefined,//number
        expiryYears: undefined,//number,
        annualTest: false,
        order: undefined,//number,
    })

    const labelValueDistance = 5

    const selectedProductData = [
        {label: "NOME", value: selectedPresidioModule?.label},
        {label: "REGISTRI", value: selectedPresidioModule?.templates?.map?.((item)=>!Array.isArray(templateRegisters) ? undefined : templateRegisters?.find?.((x)=>x?._id == item?._ref)?.family)?.toString()},
        {highlight: "green", value: selectedPresidioModule?.templatesExclude && "ESCLUDE MODELLI REGISTRI"},
        {label: "ANNI SCADENZA", value: selectedPresidioModule?.expiryYears},
        {label: "ANNI TEST", value: selectedPresidioModule?.testYears},
        {highlight: "green", value: selectedPresidioModule?.annualTest && "TEST ANNUALE"},
        {label: "ANNI REVISIONE", value: selectedPresidioModule?.revisionYears},
        {label: "ANNI REVISIONE VECCHI", value: selectedPresidioModule?.oldRevisionYears},
        {highlight: "green", value: selectedPresidioModule?.isConsole && "CENTRALE IMPIANTO"},
    ]
  
    const createNewEmptyDoc = () => {
            const okFn = (name) => {
            const docToSave = emptyDoc()
                setDoc({...docToSave, label: name})
                updateDatabase({...docToSave, label: name})
                setPresidioName(name)
            }
            addNameSwal({docType:"PRESIDIO", okFn})    
    }

    const duplicateExistingDoc = () => {
            const okFn = (name) => {
                const docToSave = duplicateDoc()
                setDoc({...docToSave, label: name})
                updateDatabase({...docToSave, label: name})
                setPresidioName(name)
            }
            addNameSwal({docType:"PRESIDIO", okFn})  
    }
    const editExistingDoc = () => {
        setDoc(selectedPresidioModule, true)
    }
    const filterByRegister = (item) => {
    if (templateRegister) return item?.templates?.some?.(y=>y?._ref == templateRegister?._id) 
    return item
    }
    const listOptions = !Array.isArray(presidioModules) ? [] : presidioModules
        ?.filter?.((x)=> {
            if(filterType?.label == "ARCHIVIATI") return x?.status == "ARCHIVIATO"
            if(filterType?.label == "ATTIVI") return x?.status !== "ARCHIVIATO"
            if(filterType?.label == "SENZA REGISTRI AGGIORNATI") return x?.templates?.length == 0 || !x?.templates
            if(filterType?.label == "CON ALCUNI REGISTRI MANCANTI") {
                const notAssignedRegisters = templateRegisters?.map((item)=>{
                    const isPresidioInTemplateRegister = item?.devices?.some((y)=>y?._ref == x?._id)
                    const isRegisterInPresidio = x?.templates?.some((y)=>y?._ref == item?._id)
                    if(isPresidioInTemplateRegister && !isRegisterInPresidio) return item?.family
                    return
                })?.filter((x)=>x)
                return notAssignedRegisters?.length > 0}
            return x 
        })
        ?.filter(filterByRegister)
        ?.map?.((pM)=>({...pM, label: pM?.label, value: pM?.label}))
    
    return (
        <div>        
            <div style={{marginBottom :"10px",display:"flex", cursor:"pointer", alignItems:"center"}} onClick={() => setViewFilterFamily(!viewFilterFamily)}>
                <h4>FILTRA PER FAMIGLIA:</h4>
                {viewFilterFamily ? <IoIosArrowDropupCircle size={25}/> : <IoIosArrowDropdownCircle size={25}/>}
            </div>
            <VisDiv rules={[viewFilterFamily]}>
                <SliderRegistriTemplates 
                    registerTemplateFilter={templateRegister} 
                    setRegisterTemplateFilter={setTemplateRegister} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    //setLoading={setLoading}
                />
            </VisDiv> 
            <h3>SELEZIONA FILTRO:</h3>
            <FieldDropdown
                sorted={true}
                isSearchable="isSearchable"
                initialValue={filterType}
                placeHolder={"SELEZIONA FILTRO"}
                options={filterTypes}
                onChange={(value) => { 
                    setFilterType(value)
                }}
            />
            <Divider />
            <FieldDropdown
                sorted={true}
                isSearchable="isSearchable"
                //initialValue={expandSupplier(supplierProduct?.supplier)}
                placeHolder={"SELEZIONA PRESIDIO ESISTENTE"}
                options={listOptions}
                onChange={(value) => { 
                    setSelectedPresidioModule(value)
                }}
            />

            <div style={{display:"flex", justifyContent:"space-evenly"}}>
                <VisDiv rules={[]}>
                    <button className="pdf-button" onClick={createNewEmptyDoc} >INSERISCI VUOTO</button>
                </VisDiv>
                <VisDiv rules={[selectedPresidioModule]}> 
                    <button className="pdf-button" onClick={editExistingDoc} >MODIFICA PRESIDIO ESISTENTE</button>
                </VisDiv>
                <VisDiv rules={[selectedPresidioModule]}>
                    <button className="pdf-button" onClick={duplicateExistingDoc} >DUPLICA PRESIDIO </button>
                </VisDiv>
            </div>
            <VisDiv rules={[selectedPresidioModule]}>
                <Divider/>
                {selectedProductData?.map?.((item,index)=>{
                    return(
                        <VisDiv key={index} rules={[item?.value]}>
                            <ViewLabelValueField 
                                label={item?.label} 
                                value={item?.value}
                                labelValueDistance={labelValueDistance}
                                highlight={item?.highlight}
                            />
                        </VisDiv>
                    )
                })}

            </VisDiv>
        </div>
    )
}



/**
 * Componente che permette di modificare il nome di un presidio
 * 
 * @param {Object} doc - il presidio da modificare
 * @param {Function} setDoc - la funzione per aggiornare il presidio
 * @param {Object} data - i dati del contesto
 * @returns {JSX.Element} - il componente che rappresenta la modifica del nome del presidio
 */
export const PresidioName = ({doc, setDoc, data}) => { 
    
    return (
        <div>

            <TextField 
                value={doc?.label} 
                onChange={(e) => setDoc({...doc, label: e.target.value})} 
                description={"Questo dato non sarà inserito nell'offerta, serve per trovare la non conformità"} 
                descriptionDivider={false}
            />
            <div style={{display:"flex", marginTop:"10px", alignItems:"center"}}>
            <button type='button' className='round-back-button' style={{backgroundColor: "#324d67", marginRight:"10px"}} onClick={()=>copyId(doc)}>
                    <FiCopy            
                    size={15}
                    color={"white"}/>
                </button>
                <h3>COPIA ID A CLIPBOARD</h3>

            </div>

        </div>
    )
}


/**
 * Componente che rappresenta le impostazioni di un presidio
 * 
 * @param {Object} doc - il presidio da modificare
 * @param {Function} setDoc - la funzione per aggiornare il presidio
 * @param {Object} data - i dati del contesto
 * @returns {JSX.Element} - il componente che rappresenta le impostazioni del presidio
 */
export const ModulePresidioSettings = ({doc, setDoc, data}) => { 

    const [oldRevisionYears, setOldRevisionYears] = useState(doc?.oldRevisionYears)
    const [revisionYears, setRevisionYears] = useState(doc?.revisionYears)
    const [testYears, setTestYears] = useState(doc?.testYears)
    const [expiryYears, setExpiryYears] = useState(doc?.expiryYears)
    const [order, setOrder] = useState(doc?.order)
    return (
        <div style={{marginTop:"10px"}}>
            <TrueFalseToggle 
                value={doc?.isConsole}
                onClick={()=>setDoc({...doc, isConsole: !doc?.isConsole})}
                label={"CENTRALE IMPIANTO"} 
                description={"Selezionare questa opzione se questo presidio è la centrale di un impianto."}
            />       
            <TextField 
                label={"ANNI DI REVISIONE"}
                description={"Quanti anni ha di revisione? Lasciare vuoto se non prevedete revisioni."}
                onBlur={()=> setDoc({...doc, revisionYears: (!Number(revisionYears) || revisionYears == 0) ? undefined : Number(revisionYears)})}
                style={{maxWidth: "400px",}}
                value={revisionYears} 
                onChange={(e) => {
                    if(e.target.value == 0) setRevisionYears(undefined)
                    else if(e.target.value == "") setRevisionYears(undefined)
                    else if(!e.target.value) setRevisionYears(undefined)
                    else setRevisionYears(e.target.value)
                }} 
                type={"number"}
            />
            <TextField 
                label={"ANNI DI REVISIONE VECCHIO"}
                description={"Quanti anni ha di vecchie revisioni? Questo campo è per gli estintori che sono stati creati prima del 2024. Lasciare vuoto se non prevedete vecchie revisioni."}
                onBlur={()=> setDoc({...doc, oldRevisionYears: (!Number(oldRevisionYears) || oldRevisionYears == 0) ? undefined : Number(oldRevisionYears)})}
                style={{maxWidth: "400px",}}
                value={oldRevisionYears} 
                onChange={(e) => {
                    if(e.target.value == 0) setOldRevisionYears(undefined)
                    else if(e.target.value == "") setOldRevisionYears(undefined)
                    else if(!e.target.value) setOldRevisionYears(undefined)
                    else setOldRevisionYears(e.target.value)
                }} 
                type={"number"}
            />
            <TextField 
                label={"ANNI DI COLLAUDO/TEST/TAGLIANDO"}
                description={"Quanti anni ha di collaudo/test/tagliando? Lasciare vuoto se non prevedete collaudi(test/revisioni)."}
                onBlur={()=> setDoc({...doc, testYears: (!Number(testYears) || testYears == 0) ? undefined : Number(testYears)})}
                style={{maxWidth: "400px",}}
                value={testYears} 
                onChange={(e) => {
                    if(e.target.value == 0) setTestYears(undefined)
                    else if(e.target.value == "") setTestYears(undefined)
                    else if(!e.target.value) setTestYears(undefined)
                    else setTestYears(e.target.value)
                }} 
                type={"number"}
            />
            <TrueFalseToggle 
                value={doc?.annualTest}
                onClick={()=>setDoc({...doc, annualTest: !doc?.annualTest})}
                label={"TEST / COLLAUDO ANNUALE"} 
                description={"Selezionare questa opzione se questo presidio richiede un test annuale, come per esempio per gli Idranti."}
            />       
            <TextField 
                label={"ANNI DI SCADENZA"}
                description={"Quanti anni ha di scadenza? Lasciare vuoto se non prevedete scadenza)."}
                onBlur={()=> setDoc({...doc, expiryYears: (!Number(expiryYears) || expiryYears == 0) ? undefined : Number(expiryYears)})}
                style={{maxWidth: "400px",}}
                value={expiryYears} 
                onChange={(e) => {
                    if(e.target.value == 0) setExpiryYears(undefined)
                    else if(e.target.value == "") setExpiryYears(undefined)
                    else if(!e.target.value) setExpiryYears(undefined)
                    else setExpiryYears(e.target.value)
                }} 
                type={"number"}
            />  
            <TextField 
                label={"ORDINE DELL OFFERTA"}
                description={"Inserire l'ordine in cui si vuole il presidio nell'offerta."}
                onBlur={()=> setDoc({...doc, order: (!Number(order) || order == 0) ? undefined : Number(order)})}
                style={{maxWidth: "400px",}}
                value={order} 
                onChange={(e) => {
                    if(e.target.value == 0) setOrder(undefined)
                    else if(e.target.value == "") setOrder(undefined)
                    else if(!e.target.value) setOrder(undefined)
                    else setOrder(e.target.value)
                }} 
                type={"number"}
            />  
        </div>
    )
}

//=======================================================================================

/**
 * Componente che rappresenta l'assegnazione di un modello di registro a un presidio
 * 
 * @param {Function} updateRegisterTemplate - la funzione per aggiornare il modello di registro
 * @param {Object} doc - il presidio da modificare
 * @param {Function} setDoc - la funzione per aggiornare il presidio
 * @param {Object} data - i dati del contesto
 * @returns {JSX.Element} - il componente che rappresenta l'assegnazione del modello di registro
 */
export const AssignRegisterTemplates = ({updateRegisterTemplate, doc, setDoc, data}) => { 

    const {referenceData} = data
    /**
     * Saves a template register to the database, adding or removing a presidio module reference depending on whether it was added or removed.
     * 
     * @param {Object} data - the data containing the template register to be saved, and whether it was added or removed
     * @returns {undefined}
     */
    const saveTemplateRegister = (data) => {
        const presidioModuleReferenceDoc = referenceDoc(doc?._id)
        const templateRegister = data?.item
        if(!templateRegister) {
            errorAlert("Nessun modello trovato")
            return
        }
        if(data?.wasAdded){
           
            const wasAlreadyThere = templateRegister?.devices?.some((x)=>x?._ref == presidioModuleReferenceDoc?._ref)
            const newTemplateRegisterDoc = {
                ...templateRegister,
                devices: [...templateRegister?.devices, presidioModuleReferenceDoc]
            }
             console.log("òldkwefkewopfk was added", {data, wasAlreadyThere, newTemplateRegisterDoc})
             if(wasAlreadyThere) return
             updateRegisterTemplate({doc: newTemplateRegisterDoc}) 
        } else {
            const newTemplateRegisterDoc = {
                ...templateRegister,
                devices: [...templateRegister?.devices?.filter((x)=>x?._ref != presidioModuleReferenceDoc?._ref)]
            }
            console.log("lqmdlqwmdlkwm was removed", {data, newTemplateRegisterDoc})
            updateRegisterTemplate({doc: newTemplateRegisterDoc}) 
        }
    }

    const notAssignedRegisters = referenceData?.data?.map((item)=>{
            const isPresidioInTemplateRegister = item?.devices?.some((x)=>x?._ref == doc?._id)
            const isRegisterInPresidio = doc?.templates?.some((x)=>x?._ref == item?._id)
            if(isPresidioInTemplateRegister && !isRegisterInPresidio) return <p>{item?.family}</p>
            return
    })?.filter((x)=>x)

    return (
        <div>
            <VisDiv rules={[notAssignedRegisters?.length>0]} style={{marginBottom:"10px", marginTop:"10px"}}>
                <h3> Presidi assegnati nel modello registro ma senza il registro assegnato: </h3>
                {notAssignedRegisters}
            </VisDiv>

            <TrueFalseToggle 
                value={doc?.templatesExclude}
                onClick={()=>setDoc({...doc, templatesExclude: !doc?.templatesExclude})}
                label={"ESCLUDI MODELLI REGISTRI"} 
                description={"Selezionare questa opzione se si vuole escludere i modelli selezionati invece di includerli. "}
            />
            <ReferenceCheckList sortKey={"family"} dataCallback={saveTemplateRegister} doc={doc} setDoc={setDoc} referenceData={referenceData}/>
            
        </div>
    )
    
}
//=======================================================================================

/**
 * TemplateOrder component
 * 
 * This component allows the user to select an existing register template, 
 * edit it, or create a new one. It also allows the user to filter the list 
 * of available register templates by their family, and to duplicate an existing 
 * register template.
 * 
 * @param {Object} data - an object containing the data needed by the component,  {presidioModules, templateRegisters} 
 * @param {Function} updateRegisterTemplate - a function that updates the database with a new or modified register template
 * @param {Function} setDoc - a function that sets the current register template
 * 
 * @returns - a JSX element
 */
export const TemplateOrder = ({updateRegisterTemplate, doc, setDoc, data}) => {
    const {templateRegisters, presidioModules} = data
    const assignedRegisterTemplates = !Array.isArray(doc?.templates) ? [] : doc?.templates?.filter?.((x)=>!x?.templatesExclude)
    const options = assignedRegisterTemplates?.map?.((x)=>{
        const findTemplate = !Array.isArray(templateRegisters) ? undefined : templateRegisters?.find?.((y)=>y?._id == x?._ref)
        if(!findTemplate?.devicesManualOrder) return
        return ({...findTemplate, label: findTemplate?.family, value: findTemplate?._id})
    }
    )?.filter(x=>x)
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const registerTemplateReferenceData = {type: "referenceArray", hideFilter:true, data: presidioModules, propertyName: "devices"}
    const saveTemplateRegister = (newDoc) => {
        console.log("jksdnsekjdfne", newDoc)
        setSelectedTemplate({...newDoc, label: newDoc?.family, value: newDoc?._id})
        updateRegisterTemplate({doc: newDoc})
    }
    return (
        <div>
            <VisDiv rules={[options?.length < 1]}>
                <div style={{textAlign:"center", color:"red", marginTop:"10px"}}>
                    <h4>NON CI SONO REGISTRI CON ORDINE MANUALE</h4>
                </div>
            </VisDiv>

            <VisDiv rules={[options?.length > 0]}>
                <FieldDropdown 
                    options={options}
                    placeHolder={"SELEZIONA UN REGISTRO"}
                    value={selectedTemplate}
                    onChange={(value) => setSelectedTemplate(value)}
                />
                <VisDiv rules={[selectedTemplate]}>
                    <ReferencesArrayBox 
                        hideDelete={true} 
                        hideAdd={true} 
                        hideEdit={true}
                        doc={selectedTemplate} setDoc={saveTemplateRegister} referenceData={registerTemplateReferenceData}/>
                </VisDiv>
                
            </VisDiv>
        </div>
    )
    
}
//========================================================================================


export default DeviceTemplatesManagement
